/**
 * Stable client-side device fingerprint generator
 * Gathers hardware, browser environment, canvas rendering hash, and persistent UUID
 */

function generateUUID() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return "cr-dev-" + Math.random().toString(36).substring(2, 15) + Date.now().toString(36);
}

function getOrCreateDeviceId() {
  try {
    const key = "cr_device_uuid";
    let id = localStorage.getItem(key);
    if (!id) {
      id = generateUUID();
      localStorage.setItem(key, id);
    }
    return id;
  } catch (e) {
    return generateUUID();
  }
}

// Simple deterministic string hash (djb2 / murmur-style)
function hashString(str) {
  let hash = 5381;
  for (let i = 0; i < str.length; i++) {
    hash = (hash * 33) ^ str.charCodeAt(i);
  }
  return (hash >>> 0).toString(16);
}

function getCanvasFingerprint() {
  try {
    const canvas = document.createElement("canvas");
    canvas.width = 200;
    canvas.height = 50;
    const ctx = canvas.getContext("2d");
    if (!ctx) return "";

    ctx.textBaseline = "top";
    ctx.font = "14px 'Arial', sans-serif";
    ctx.textBaseline = "alphabetic";
    ctx.fillStyle = "#f60";
    ctx.fillRect(125, 1, 62, 20);
    ctx.fillStyle = "#069";
    ctx.fillText("CloudRasoi-Secured, 👨‍🍳🔥", 2, 15);
    ctx.fillStyle = "rgba(102, 204, 0, 0.7)";
    ctx.fillText("CloudRasoi-Secured, 👨‍🍳🔥", 4, 17);

    const dataUrl = canvas.toDataURL();
    return hashString(dataUrl);
  } catch (e) {
    return "";
  }
}

export function getDeviceFingerprint() {
  const deviceId = getOrCreateDeviceId();
  const screenWidth = typeof window !== "undefined" ? window.screen.width : 0;
  const screenHeight = typeof window !== "undefined" ? window.screen.height : 0;
  const pixelRatio = typeof window !== "undefined" ? window.devicePixelRatio || 1 : 1;
  const colorDepth = typeof window !== "undefined" ? window.screen.colorDepth || 24 : 24;
  const language = typeof navigator !== "undefined" ? navigator.language || "en" : "en";
  const platform =
    typeof navigator !== "undefined"
      ? (navigator.userAgentData && navigator.userAgentData.platform) || navigator.platform || ""
      : "";
  const timezone =
    typeof Intl !== "undefined" && Intl.DateTimeFormat
      ? Intl.DateTimeFormat().resolvedOptions().timeZone
      : "";
  const hardwareConcurrency = typeof navigator !== "undefined" ? navigator.hardwareConcurrency || 0 : 0;
  const canvasHash = getCanvasFingerprint();

  const rawFingerprint = [
    deviceId,
    screenWidth,
    screenHeight,
    pixelRatio,
    colorDepth,
    language,
    platform,
    timezone,
    hardwareConcurrency,
    canvasHash,
  ].join("::");

  const fingerprint = `CR-${hashString(rawFingerprint)}`;

  return {
    fingerprint,
    deviceId,
    screenWidth,
    screenHeight,
    pixelRatio,
    platform,
    language,
    timezone,
  };
}

export default getDeviceFingerprint;
